import { CommonButtonState } from "../enums/CommonButtonState";
import { MODAL_SELECTORS } from "../components/Modal/instance/modalSelectors";

export const InitialActionButtonState = {
  ...CommonButtonState,
  InsufficientAllowance: "InsufficientAllowance",
  InsufficientPermissions: "InsufficientPermissions",
  Wrapping: "Wrapping",
  Unwrapping: "Unwrapping",
  WrongNetwork: "WrongNetwork",
  SelectTokens: "SelectTokens",
  PlaceTrade: "PlaceTrade",
  IgnoreAndPlaceTrade: "IgnoreAndPlaceTrade",
  RequestingQuote: "RequestingQuote",
  WarningRequestingQuote: "WarningRequestingQuote",
  WrappingQuote: "WrappingQuote",
  EnterAmounts: "EnterAmounts",
  Error: "Error",
  IncreaseOrderSize: "IncreaseOrderSize",
  AddressLoading: "AddressLoading",
  NoPricing: "NoPricing",
  ConfirmingOrder: "ConfirmingOrder",
  InProgress: "InProgress",
};

export type ActionButtonStateKeys = keyof typeof InitialActionButtonState;

export const enum BUTTON_TEXTS {
  PlaceTrade = "Place trade",
  PlaceTradeAnyway = "Place trade anyway",
  Continue = "Continue",
  ConnectWallet = "Connect wallet",
  ConfirmInWallet = "Confirm in wallet",
  WrongNetwork = "Wrong network",
  Processing = "Processing",
  Wrap = "Wrap",
  Unwrap = "Unwrap",
  InsufficientAllowance = "Grant permissions",
}

export const INITIAL_BUTTON_TEXT_MAP: Partial<Record<ActionButtonStateKeys, string>> = {
  WalletNotConnected: BUTTON_TEXTS.ConnectWallet,
  InsufficientAllowance: BUTTON_TEXTS.InsufficientAllowance,
  InsufficientPermissions: BUTTON_TEXTS.InsufficientAllowance,
  Wrapping: BUTTON_TEXTS.Wrap,
  Unwrapping: BUTTON_TEXTS.Unwrap,
  InsufficientBalance: BUTTON_TEXTS.PlaceTrade,
  SelectTokens: BUTTON_TEXTS.PlaceTrade,
  WrongNetwork: BUTTON_TEXTS.WrongNetwork,
  NoPricing: BUTTON_TEXTS.PlaceTrade,
  EnterAmounts: BUTTON_TEXTS.PlaceTrade,
  PlaceTrade: BUTTON_TEXTS.PlaceTrade,
  IgnoreAndPlaceTrade: BUTTON_TEXTS.PlaceTradeAnyway,
  WarningRequestingQuote: BUTTON_TEXTS.PlaceTradeAnyway,
  Error: BUTTON_TEXTS.PlaceTrade,
  IncreaseOrderSize: BUTTON_TEXTS.PlaceTrade,
  AddressLoading: BUTTON_TEXTS.PlaceTrade,
  ConfirmingOrder: BUTTON_TEXTS.ConfirmInWallet,
  InProgress: BUTTON_TEXTS.Processing,
};

export const BUTTON_DISABLED_MAP: Partial<Record<ActionButtonStateKeys, boolean>> = {
  WalletNotConnected: false,
  InsufficientAllowance: false,
  InsufficientPermissions: false,
  WrappingQuote: false,
  Wrapping: false,
  Unwrapping: false,
  InsufficientBalance: true,
  WrongNetwork: true,
  SelectTokens: true,
  NoPricing: true,
  PlaceTrade: false,
  IgnoreAndPlaceTrade: false,
  RequestingQuote: false,
  WarningRequestingQuote: false,
  EnterAmounts: true,
  Error: true,
  IncreaseOrderSize: true,
  AddressLoading: true,
  ConfirmingOrder: true,
  InProgress: true,
};

export const PROGRESSION_STATES = [
  InitialActionButtonState.PlaceTrade,
  InitialActionButtonState.IgnoreAndPlaceTrade,
  InitialActionButtonState.InsufficientAllowance,
  InitialActionButtonState.Wrapping,
  InitialActionButtonState.Unwrapping,
  InitialActionButtonState.InsufficientPermissions,
];

export const BUTTON_MODAL_MAP: Partial<Record<ActionButtonStateKeys, MODAL_SELECTORS>> = {
  WalletNotConnected: MODAL_SELECTORS.WALLET_CONNECT,
};
